import { ref } from 'vue'

// Which of the two shells is on screen. Production switches at 769px (desktop sidebar shell from 769px up,
// phone client shell below); the legacy stylesheets are generated with the same media queries, and
// body.desktop-ui / body.client-ui are the classes they key on.
export const DESKTOP_QUERY = '(min-width: 769px)'

const mql = typeof matchMedia === 'function' ? matchMedia(DESKTOP_QUERY) : null
export const isDesktop = ref(mql ? mql.matches : true)

export function applyShellClasses() {
  document.body.classList.toggle('desktop-ui', isDesktop.value)
  document.body.classList.toggle('client-ui', !isDesktop.value)
}

export function setViewAttribute(view: string) {
  document.body.dataset.view = view
}

mql?.addEventListener('change', event => {
  isDesktop.value = event.matches
  applyShellClasses()
})
